import { STORAGE_KEYS, UI_CONSTANTS } from '@/constants';
import { PersistedIDEState, validateStoredIDEState } from './ide-storage';

export const storage = {
    get: <T>(key: string, defaultValue: T): T => {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : defaultValue;
        } catch (error) {
            console.warn(`Failed to get item from localStorage: ${key}`, error);
            return defaultValue;
        }
    },

    set: <T>(key: string, value: T): void => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.warn(`Failed to set item in localStorage: ${key}`, error);
        }
    },

    remove: (key: string): void => {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.warn(`Failed to remove item from localStorage: ${key}`, error);
        }
    },

    clear: (): void => {
        try {
            localStorage.clear();
        } catch (error) {
            console.warn('Failed to clear localStorage', error);
        }
    },
};

// Specific storage functions for the portfolio app
export const portfolioStorage = {
    getRecentFiles: (): string[] => {
        const saved = storage.get<unknown>(STORAGE_KEYS.RECENT_FILES, []);
        return Array.isArray(saved)
            ? [...new Set(saved.filter((id): id is string => typeof id === 'string'))].slice(
                  0,
                  UI_CONSTANTS.RECENT_FILES_MAX_COUNT
              )
            : [];
    },

    setRecentFiles: (files: string[]): void => {
        storage.set(STORAGE_KEYS.RECENT_FILES, files);
    },

    addRecentFile: (fileId: string): void => {
        const recentFiles = portfolioStorage.getRecentFiles();
        const filteredFiles = recentFiles.filter(id => id !== fileId);
        const newRecentFiles = [fileId, ...filteredFiles].slice(0, UI_CONSTANTS.RECENT_FILES_MAX_COUNT);
        portfolioStorage.setRecentFiles(newRecentFiles);
    },

    getIDEState: () => {
        return validateStoredIDEState(storage.get<unknown>(STORAGE_KEYS.IDE_STATE, null));
    },

    setIDEState: (state: PersistedIDEState): void => {
        storage.set(STORAGE_KEYS.IDE_STATE, state);
    },
};
